interface ScreenWithDollarSignAndGearSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ScreenWithDollarSignAndGearSVG = ({
  color,
  style,
}: ScreenWithDollarSignAndGearSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="61"
    height="50"
    viewBox="0 0 61 50"
    fill="none"
  >
    <g clipPath="url(#clip0_678_13051)">
      <path
        d="M54.6675 38.3099C54.6675 41.2191 52.3018 43.5848 49.3926 43.5848C46.4834 43.5848 44.1177 41.2191 44.1177 38.3099C44.1177 35.4007 46.4834 33.0349 49.3926 33.0349C52.3018 33.0349 54.6675 35.4007 54.6675 38.3099Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
      />
      <path
        d="M59.495 34.8252L59.932 34.367L58.0671 31.1381L57.4597 31.2873C56.2129 31.5963 54.9021 31.3832 53.7938 30.7332C53.7832 30.7332 53.7725 30.7225 53.7512 30.7118C52.6323 30.0725 51.7798 29.0388 51.4281 27.8026L51.2576 27.1952H47.5385L47.368 27.8026C47.0057 29.0388 46.1638 30.0725 45.0449 30.7118C45.0449 30.7118 45.0343 30.7118 45.0236 30.7118H45.0023C43.8834 31.3725 42.5726 31.5857 41.3258 31.2766L40.7184 31.1274L38.8535 34.3563L39.2904 34.8039C40.1856 35.731 40.6545 36.9778 40.6545 38.2779C40.6545 38.2886 40.6545 38.3099 40.6545 38.3205C40.6545 39.61 40.1856 40.8461 39.2904 41.7732L38.8535 42.2315L40.7184 45.4604L41.3258 45.3112C42.5726 45.0021 43.8834 45.2153 44.9916 45.8653C45.0023 45.8653 45.0129 45.876 45.0342 45.8866C46.1532 46.526 47.0057 47.5597 47.3574 48.7958L47.5279 49.4032H51.247L51.4175 48.7958C51.7798 47.5597 52.6216 46.526 53.7406 45.8866C53.7406 45.8866 53.7512 45.8866 53.7619 45.8866C53.7619 45.8866 53.7725 45.8866 53.7832 45.8866C54.9021 45.2366 56.2129 45.0234 57.4597 45.3325L58.0671 45.4817L59.932 42.2528L59.495 41.8052C58.5999 40.8781 58.131 39.6313 58.131 38.3312C58.131 38.3205 58.131 38.2992 58.131 38.2886C58.131 36.9991 58.5999 35.763 59.495 34.8359V34.8252Z"
        stroke={color}
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.0097 40.4944H3.9428C2.08858 40.4944 0.59668 38.9919 0.59668 37.1483V3.21822C0.59668 1.76895 1.76889 0.596741 3.21816 0.596741H46.771C48.2203 0.596741 49.3925 1.76895 49.3925 3.21822V24.3926"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.15034 5.86103C7.15034 5.60527 6.94787 5.4028 6.69211 5.4028C6.43636 5.4028 6.23389 5.60527 6.23389 5.86103C6.23389 6.11678 6.43636 6.31925 6.69211 6.31925C6.94787 6.31925 7.15034 6.11678 7.15034 5.86103Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3833 5.86103C12.3833 5.60527 12.1808 5.4028 11.925 5.4028C11.6693 5.4028 11.4668 5.60527 11.4668 5.86103C11.4668 6.11678 11.6693 6.31925 11.925 6.31925C12.1808 6.31925 12.3833 6.11678 12.3833 5.86103Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6259 5.86103C17.6259 5.60527 17.4235 5.4028 17.1677 5.4028C16.9119 5.4028 16.7095 5.60527 16.7095 5.86103C16.7095 6.11678 16.9119 6.31925 17.1677 6.31925C17.4235 6.31925 17.6259 6.11678 17.6259 5.86103Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.59668 11.04H49.3925"
        stroke={color}
        strokeWidth="1.19352"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4209 28.0904C22.4209 29.5077 23.5718 30.6586 24.9891 30.6586C26.4064 30.6586 27.5573 29.5077 27.5573 28.0904C27.5573 26.6731 26.5023 26.0124 24.9891 25.5222C23.6357 25.0853 22.4209 24.3713 22.4209 22.954C22.4209 21.5367 23.5718 20.3858 24.9891 20.3858C26.4064 20.3858 27.5573 21.5367 27.5573 22.954"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9893 18.9471V20.3964"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9893 30.6585V32.1185"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5062 27.7654C35.746 22.5128 32.4929 17.2498 27.2403 16.0101C21.9877 14.7703 16.7247 18.0234 15.4849 23.276C14.2452 28.5286 17.4983 33.7916 22.7509 35.0313C28.0035 36.2711 33.2665 33.018 34.5062 27.7654Z"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_678_13051">
        <rect width="60.6777" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ScreenWithDollarSignAndGearSVG;
